import { ModalMessage } from "./ModalMessage";
export default ModalMessage;